import { theme as baseTheme } from 'smooth-doc/src/theme';
import { css } from '@xstyled/styled-components';

export const theme = {
  ...baseTheme,
  screens: {
    '2xl': 1440,
    xl: 1280,
    lg: 960,
    md: 600,
    sm: 360,
    xs: 0
  },
  colors: {
    ...baseTheme.colors,
    primary: '#0FA789',
    'primary-600': '#0FA789', // for smooth-doc button
    'primary-700': '#0FA789', // for smooth-doc button
    'editor-background': '#F3F5F8',
    'blockquote-background': '#EAD35580'
  },
  fonts: {
    base: "'Roboto', 'sans-serif'",
    cabin: "'Cabin', 'sans-serif'"
  },
  lineHeights: {
    none: 1,
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
    3: '.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    // Match fontSizes
    xs: '1rem',
    sm: '1.25rem',
    default: '1.5rem',
    lg: '1.75rem',
    xl: '1.75rem',
    '2xl': '2rem',
    '3xl': '2.25rem',
    '4xl': '2.5rem',
    '5xl': 1,
    '6xl': 1,
    '7xl': 1,
    '8xl': 1,
    '9xl': 1
  },
  space: {
    ...baseTheme.space,
    0.5: '0.125rem',
    1: '0.25rem',
    1.5: '0.375rem',
    2: '0.5rem',
    2.5: '0.625rem',
    3: '0.75rem',
    3.5: '0.875rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem'
  },
  radii: {
    base: 6
  },
  'prism-theme': () => ({
    styles: [
      {
        types: ['comment'],
        style: {
          color: '#3CA714'
        }
      },
      {
        types: ['keyword'],
        style: {
          color: '#1482A7'
        }
      },
      {
        types: ['string'],
        style: {
          color: '#E3720E'
        }
      },
      {
        types: ['token-line'],
        style: {
          color: '#000000'
        }
      }
    ]
  }),
  global: css`
    html,
    body {
      font-family: 'Roboto', 'sans-serif' !important;
    }
    a,
    button {
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  `.concat(baseTheme.global)
};
